export const userConstant = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    GET_USER_REQUEST: "GET_USER_REQUEST",
    GET_USER_SUCCESS: "GET_USER_SUCCESS",
    GET_USER_FAILURE: "GET_USER_FAILURE",
    RESET_USER_STATUS:"RESET_USER_STATUS",

    CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
    CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
    CHANGE_PASSWORD_FAILURE: "CHANGE_PASSWORD_FAILURE",

    SEND_TEMP_PASSWORD_REQUEST: " SEND_TEMP_PASSWORD_REQUEST",
    SEND_TEMP_PASSWORD_SUCCESS: " SEND_TEMP_PASSWORD_SUCCESS",
    SEND_TEMP_PASSWORD_FAILURE: " SEND_TEMP_PASSWORD_FAILURE",

    SEND_AUTHCODE_REQUEST: " SEND_AUTHCODE_REQUEST",
    SEND_AUTHCODE_SUCCESS: " SEND_AUTHCODE_SUCCESS",
    SEND_AUTHCODE_FAILURE: " SEND_AUTHCODE_FAILURE",

    GET_USERS_REQUEST: "GET_USERS_REQUEST",
    GET_USERS_SUCCESS: "GET_USERS_SUCCESS",
    GET_USERS_FAILURE: "GET_USERS_FAILURE",

    CREATE_USER_REQUEST: "CREATE_USER_REQUEST",
    CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
    CREATE_USER_FAILURE: "CREATE_USER_FAILURE",

    UPDATE_USER_REQUEST: "UPDATE_USER_REQUEST",
    UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
    UPDATE_USER_FAILURE: "UPDATE_USER_FAILURE",
    
    DELETE_USER_REQUEST: "DELETE_USER_REQUEST",
    DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
    DELETE_USER_FALIURE: "DELETE_USER_FAILURE",

    SIGN_UP_REQUEST: "SIGN_UP_REQUEST",
    SIGN_UP_SUCCESS: "SIGN_UP_SUCCESS",
    SIGN_UP_FALIURE: "SIGN_UP_FAILURE",

    DISABLE_USER_REQUEST: "DISABLE_USER_REQUEST",
    DISABLE_USER_SUCCESS: "DISABLE_USER_SUCCESS",
    DISABLE_USER_FALIURE: "DISABLE_USER_FAILURE",

    ENABLE_USER_REQUEST: "ENABLE_USER_REQUEST",
    ENABLE_USER_SUCCESS: "ENABLE_USER_SUCCESS",
    ENABLE_USER_FALIURE: "ENABLE_USER_FAILURE",

    GET_USER_MENU_LIST_REQUEST: "GET_USER_MENU_LIST_REQUEST",
    GET_USER_MENU_LIST_SUCCESS: "GET_USER_MENU_LIST_SUCCESS",
    GET_USER_MENU_LIST_FAILURE: "GET_USER_MENU_LIST_FAILURE",

    GET_USER_MENU_URLS_LIST_REQUEST: "GET_USER_MENU_URLS_LIST_REQUEST",
    GET_USER_MENU_URLS_LIST_SUCCESS: "GET_USER_MENU_URLS_LIST_SUCCESS",
    GET_USER_MENU_URLS_LIST_FAILURE: "GET_USER_MENU_URLS_LIST_FAILURE",

    GET_USER_NAVIGATION_MENU_URL_LIST_REQUEST: "GET_USER_NAVIGATION_MENU_URL_LIST_REQUEST",
    GET_USER_NAVIGATION_MENU_URL_LIST_SUCCESS: "GET_USER_NAVIGATION_MENU_URL_LIST_SUCCESS",
    GET_USER_NAVIGATION_MENU_URL_LIST_FAILURE: "GET_USER_NAVIGATION_MENU_URL_LIST_FAILURE",

    RESET_NAVIGATION_MENU_URL_LIST: "RESET_NAVIGATION_MENU_URL_LIST",

    RESET_FORGOT_PASSWORD_DATA: "RESET_FORGOT_PASSWORD_DATA",
    RESET_CHANGE_PASSWORD_DATA:"RESET_CHANGE_PASSWORD_DATA",
    
    LOGOUT: 'USERS_LOGOUT',

    RESET_API_MESSAGES :'RESET_API_MESSAGES',
    RESET_USER_DATA :'RESET_USER_DATA',
    RESET_MENU_DATA:'RESET_MENU_DATA',

    UPDATE_PROFILE_REQUEST: "UPDATE_PROFILE_REQUEST",
    UPDATE_PROFILE_SUCCESS: "UPDATE_PROFILE_SUCCESS",
    UPDATE_PROFILE_FAILURE: "UPDATE_PROFILE_FAILURE",
};